@if (collar()) {
  <div class="collar-details__container">
    <div class="collar-details__details">
      @if (showMore()) {
        <vectronic-details-item header="Collar Name">
          <ng-container>{{ collar().name }}</ng-container>
        </vectronic-details-item>
      }
      @if (deviceTypeName() && showExtraInfo()) {
        <vectronic-details-item header="Device Type">
          <ng-container>
            {{ deviceTypeName() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (beaconFrequency() && showExtraInfo()) {
        <vectronic-details-item header="Frequency">
          <ng-container>
            {{ (beaconFrequency() / 1000000).toFixed(3) + ' MHz' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView()) {
        <vectronic-details-item header="Com ID">
          <ng-container> {{ comId() }}</ng-container>
        </vectronic-details-item>
      }
      @if ((inMobileView() || showExtraInfo()) && collar().comType) {
        <vectronic-details-item header="Com Type">
          <ng-container> {{ translateComType(collar().comType) }}</ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView() && currentDeployment()) {
        <vectronic-details-item header="Assigned Animal">
          <ng-container>
            {{
              currentDeployment().animalName +
                ' - Deployd: ' +
                getDeploymentDateRange(currentDeployment())
            }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (isCustomerCollar()) {
        @if (customerCollar().label) {
          <vectronic-details-item header="Personal Notes">
            <ng-container
              >{{
                customerCollar().label.length > 40
                  ? (customerCollar().label | slice: 0 : 40) + '...'
                  : customerCollar().label
              }}
            </ng-container>
          </vectronic-details-item>
        }
        @if (customerCollar().description) {
          <vectronic-details-item header="Description">
            <ng-container>
              {{
                customerCollar().description.length > 40
                  ? (customerCollar().description | slice: 0 : 40) + '...'
                  : customerCollar().description
              }}
            </ng-container>
          </vectronic-details-item>
        }
        @if (collarGroups()?.length) {
          <vectronic-details-item header="Groups">
            @for (group of collarGroups(); track group.id; let last = $last) {
              <span title="{{ group.name.length > 15 ? group.name : '' }}">
                {{ group.name.length > 15 ? group.name.slice(0, 15) + '...' : group.name }}
                @if (!last) {
                  ,
                }
              </span>
            }
          </vectronic-details-item>
        }
        @if ((inMobileView() || showExtraInfo()) && customerCollar().positionCount) {
          <vectronic-details-item header="Position Count">
            <ng-container> {{ customerCollar().positionCount?.toString() }}</ng-container>
          </vectronic-details-item>
        }
      }
      @if (inMobileView() && lastPosition()?.latitude) {
        <vectronic-details-item header="Recent Position LAT/LON">
          <ng-container>
            {{
              roundPosition(lastPosition()) +
                ' - From: ' +
                (lastPosition()?.acquisitionTime.replace('Z', '') | date: 'yyyy-MM-dd HH:mm:ss')
            }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView() && collar().distanceLastPosition) {
        <vectronic-details-item header="Distance to last Position">
          <ng-container>
            {{ getRoundNumber(collar().distanceLastPosition) + ' m' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView()) {
        <vectronic-details-item header="Status">
          <ng-container>
            {{ translateMortalityStatusShort(lastPosition()?.mortalityStatus) }}
          </ng-container>
        </vectronic-details-item>
      }
      @if ((inMobileView() || showExtraInfo()) && collarLastReception()) {
        <vectronic-details-item header="Last Reception [UTC]">
          <ng-container>
            {{ collarLastReception() | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView() && lastPosition()?.altitude) {
        <vectronic-details-item header="Recent Altitude">
          <ng-container>
            {{ lastPosition()?.altitude?.toString() + ' m' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView() && lastPosition()?.temperature) {
        <vectronic-details-item header="Recent Temperature">
          <ng-container>
            {{ lastPosition()?.temperature?.toString() + ' °C' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (inMobileView() && lastPosition()?.backupVoltage) {
        <vectronic-details-item header="Recent Beacon Voltage">
          <ng-container>
            {{ lastPosition()?.backupVoltage?.toString() + ' V' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if ((inMobileView() || showExtraInfo()) && lastPosition()?.mainVoltage) {
        <vectronic-details-item header="Recent Main Voltage">
          <ng-container>
            {{ lastPosition()?.mainVoltage?.toString() + ' V' }}
          </ng-container>
        </vectronic-details-item>
      }
      <vectronic-details-item header="Movebank">
        <ng-container>
          <mat-slide-toggle
            [disabled]="movebankSliderShouldBeDisabled()"
            [checked]="isMovebankSyncEnabled()"
            (change)="
              movebankToggle($event, canSyncWithMovebank(), collarId(), isMovebankSyncEnabled())
            "
            aria-label="Auto forward new data to Movebank"
            matTooltip="Auto forward new data to Movebank"
          ></mat-slide-toggle>
          @if (canSyncWithMovebank()) {
            <button
              class="sync-btn"
              mat-icon-button
              aria-label="Sync collar's data with Movebank"
              matTooltip="Sync collar's data with Movebank"
              (click)="syncCollarWithMovebank(canSyncWithMovebank(), collarId())"
            >
              <mat-icon>sync</mat-icon>
            </button>
          }
        </ng-container>
      </vectronic-details-item>

      @if (animalSpecie()?.english) {
        <vectronic-details-item header="Species">
          <ng-container> {{ animalSpecie()?.english }}</ng-container>
        </vectronic-details-item>
      }
      @if (isAdminCollar()) {
        @if (adminCollar().knownToSendBrokenMessages) {
          <vectronic-details-item header="Broken Message">
            <ng-container> {{ adminCollar().knownToSendBrokenMessages }}</ng-container>
          </vectronic-details-item>
        }
        @if (adminCollar().comProviderTimeline) {
          <vectronic-details-item header="Com Provider">
            <ng-container>
              {{ getCurrentTimespan(adminCollar().comProviderTimeline)?.data }}</ng-container
            >
          </vectronic-details-item>
        }
        @if (adminCollar().testDevice) {
          <vectronic-details-item header="Test Device">
            <ng-container> {{ adminCollar().testDevice }}</ng-container>
          </vectronic-details-item>
        }
        @if (adminCollar().insertTs) {
          <vectronic-details-item header="Creation Date">
            <ng-container>
              {{ adminCollar().insertTs | date: 'yyyy-MM-dd HH:mm:ss' : 'UTC' }}
            </ng-container>
          </vectronic-details-item>
        }
        @if (adminCollar().gpsPlusDevice) {
          <vectronic-details-item header="GPS Plus Device">
            <ng-container> {{ adminCollar().gpsPlusDevice }}</ng-container>
          </vectronic-details-item>
        }
        @if (build()?.shipment?.shippedAt) {
          <vectronic-details-item header="Shipping Date">
            <ng-container> {{ toFormattedDate(build()?.shipment?.shippedAt) }}</ng-container>
          </vectronic-details-item>
        }
        @if (build()?.customerRefNo) {
          <vectronic-details-item header="Organization">
            <ng-container> {{ build()?.customerRefNo }}</ng-container>
          </vectronic-details-item>
        }
        @if (build()?.customerContact) {
          <vectronic-details-item header="Customer Contact">
            <ng-container> {{ build()?.customerContact }}</ng-container>
          </vectronic-details-item>
        }
        @if (adminCollar().replacedById) {
          <vectronic-details-item header="Replaced By">
            <ng-container> {{ adminCollar().replacedById }}</ng-container>
          </vectronic-details-item>
        }
        @if (adminCollar().warranty) {
          <vectronic-details-item header="Warranty">
            <ng-container> {{ adminCollar().warranty | date: 'yyyy-MM-dd' }}</ng-container>
          </vectronic-details-item>
        }
        @if (build()?.orderItemConfigurationId) {
          <vectronic-details-item header="Order">
            <ng-container> {{ build()?.orderItemConfigurationId }}</ng-container>
          </vectronic-details-item>
        }
      }
    </div>
    <div class="collar-details__footer">
      @if (showLink()) {
        <button mat-button (click)="navigateToCollar()" matTooltip="View collar">
          <mat-icon color="accent">visibility</mat-icon>
          Collar
        </button>
      }
    </div>
  </div>
}
